/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CrefoCancelStandardMonitoringResponseDto } from '../../models/crefo-cancel-standard-monitoring-response-dto';

export interface CancelStandardMonitoring$Params {
  referenceNumber: number;
  customerGUID: string;
}

export function cancelStandardMonitoring(http: HttpClient, rootUrl: string, params: CancelStandardMonitoring$Params, context?: HttpContext): Observable<StrictHttpResponse<CrefoCancelStandardMonitoringResponseDto>> {
  const rb = new RequestBuilder(rootUrl, cancelStandardMonitoring.PATH, 'post');
  if (params) {
    rb.query('referenceNumber', params.referenceNumber, {});
    rb.query('customerGUID', params.customerGUID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CrefoCancelStandardMonitoringResponseDto>;
    })
  );
}

cancelStandardMonitoring.PATH = '/crefo/monitoring/standard/cancel';
